import { render, staticRenderFns } from "./Frage_9.vue?vue&type=template&id=fa19624c&"
import script from "./Frage_9.vue?vue&type=script&lang=js&"
export * from "./Frage_9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports